var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdiHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.5003 52.4854L25.9357 49.2404C13.2753 37.76 4.91699 30.1638 4.91699 20.8958C4.91699 13.2996 10.8662 7.375 18.4378 7.375C22.7153 7.375 26.8207 9.36625 29.5003 12.4883C32.1799 9.36625 36.2853 7.375 40.5628 7.375C48.1345 7.375 54.0837 13.2996 54.0837 20.8958C54.0837 30.1638 45.7253 37.76 33.0649 49.2404L29.5003 52.4854Z",
    fill: "#1778E1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiHeart);
export default __webpack_public_path__ + "static/media/mdi-heart.407b76a5.svg";
export { ForwardRef as ReactComponent };